import React, { useRef } from 'react'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import EsccValidationListUI from '../../../components/superUser/loan/EsccValidationListUI.js'
import EsccValidateModalSF from '../../../components/superUser/loan/EsccValidateModalSF.js'
import EsccRecipientsListSF from '../../../components/superUser/loan/EsccRecipientsListSF.js'

const EsccValidationPageUI = ({ context, errorList, esccValidationList,
    onRefreshClick, onValidateClick, updateMode, onCancelClick, selectedAccount
  }) => {
  const recipientsRef = useRef(null)

  const handleRefreshAll = () => {
    onRefreshClick()
    if (recipientsRef.current) recipientsRef.current.loadRecipients()
  }

  return (
  <SuperUserHomePageUI context={context} className='pg_su_escc' topnav='accounts'
   headerText='ESCC Account Validation Status' centered={!esccValidationList} page='esccValidation'
  >
    {
      !esccValidationList &&
      <SpinnerComponentUI />
    }
  <div className='g_flex_h g_m_bottom_100'>
      <IconButtonUI icon='icon-refresh' onClick={handleRefreshAll} />
    </div>
    <div className='g_flex_h' style={{ alignItems: 'flex-start' }}>
      <div style={{ flex: 2 }}>
        {
          esccValidationList &&
          <EsccValidationListUI
            context={context}
            esccValidationList={esccValidationList}
            onRefreshClick={onRefreshClick}
            onValidateClick={onValidateClick}
          />
        }
      </div>
      <div style={{ flex: 1, marginLeft: '40px' }}>
        <EsccRecipientsListSF context={context} ref={recipientsRef} />
      </div>
    </div>
 {
      updateMode && selectedAccount &&
      <EsccValidateModalSF
        context={context}
        updateMode={updateMode}
        onCancelClick={onCancelClick}
        onRefreshClick={onRefreshClick}
        bankAccountNumber={selectedAccount.bankAccountNumber}
        accountName={selectedAccount.accountName}
      />
    }
  </SuperUserHomePageUI>
  )
}

export default EsccValidationPageUI